import { render, staticRenderFns } from "./payment_accounts.vue?vue&type=template&id=32ded2b6"
import script from "./payment_accounts.vue?vue&type=script&lang=js"
export * from "./payment_accounts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports